import React, { createContext, useState, useEffect } from "react";
import { fetchFromApi } from "./api"; // Ensure this function supports dynamic base URLs
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [citoyenId, setCitoyenId] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        
        const token = Cookies.get("access_token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const citoyenId = decodedToken.citoyen_id;
          setToken(token);
          setCitoyenId(citoyenId);

          // Fetch user data based on citoyenId
          const response = await fetchFromApi(`${BASE_URL}/citoyen-by-id/${citoyenId}`);
          const data = await response.json();
          setUser(data);
        }
      } catch (error) {
        console.error("Error fetching user data or decoding token:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  });

  return (
    <UserContext.Provider value={{ user, loading, citoyenId,token }}>
      {children}
    </UserContext.Provider>
  );
};
